export default {"src":"/_next/static/media/road-connection.2cef9951.svg","height":12,"width":16,"blurWidth":0,"blurHeight":0};